import Appbar from '@components/Layout/Appbar';
import { SignIn } from '@components/SignIn';
import { Layouts } from '@interfaces/layouts';
import { PageTypes } from '@interfaces/pageType';
import VibxLogoWhite from '@public/assets/vibx-logo-white.svg';

/**
 * A tela que precisa ranquear em `vibx login`.
 *
 * Um markup só, escolhido por media query, no lugar de duas árvores escolhidas por
 * `window.screen.width` dentro de um `ClientSideOnly`: aquele par devolvia `null` no servidor, então
 * o HTML que o Google recebia não tinha o `<h1>Login</h1>` nem o formulário — só aparecia quando a
 * fila de renderização dele executasse o JS, dias depois de cada rastreio. Ver
 * `PublicPageWrapper` em `_app`, que é o outro portão que segurava isto.
 *
 * De quebra corrige o breakpoint: `window.screen.width` é o tamanho da TELA do aparelho, não o da
 * janela — quem estreitava a janela num monitor grande continuava recebendo o layout de desktop.
 */
export default function SignInPage() {
  return (
    <div className="flex flex-col min-h-screen lg:grid lg:grid-cols-[1.3fr_1fr]">
      <Appbar somenteMobile />

      <div className="relative hidden w-full h-full bg-primary bg-repeat-y bg-right lg:block">
        <VibxLogoWhite
          alt="Logo da VibX"
          className="absolute -translate-y-1/2 translate-x-1/2 top-1/2 right-1/2"
          height="180"
        />
      </div>

      <main className="flex flex-col items-center justify-center flex-1 p-main mt-navbarHeight lg:mt-0">
        <SignIn />
      </main>
    </div>
  );
}

SignInPage.pageType = PageTypes.PUBLIC;
SignInPage.layout = Layouts.NONE;
SignInPage.renderizaSemSessao = true;
